import React,{useEffect, useState} from 'react'
import PIC from "../images/PIC.png"
import { useNavigate } from 'react-router-dom'



function About() {
  const navigate = useNavigate();
  
  const [userData, setUserData] = useState({})
  
  const callAboutPage = async () =>{
  
  try {
    const res = await fetch('/about',{
      method:"GET",
      headers:{
        Accept:"application/json",
        "Content-Type":"application/json"
      },
      credentials: "include"
    });
    const data = await res.json();
    console.log(data);
    setUserData(data);
    if(!res.status ===200){
      const error = new Error(res.error);
      throw error;
    }
  } catch (error) {
   console.log(error);
   navigate('/signin') 
  }
    
  }
  
  useEffect(() => {
      callAboutPage();
  }, [])
  return (
  <div style={{minHeight: "100vh",padding: "10vh 0vh"}} className='contact bg-light my-auto'>
        <div className='container bg-white border mx-auto w-75 rounded p-5'>
         <form method='GET'>
          <div className='row'>
            <div className='col-lg-4'>
                <img className='img-fluid rounded' src={PIC} alt='pic' width="225px" height="225px"></img>
            </div>
            <div className='col-lg-6'>
              <div className='profile-head'>
                <h5>{userData.name}</h5>
                <h6 className='text-primary'>{userData.work}</h6>
                <p className='mt-3 mb-5'>RANKING: <span className='font-weight-bold text-primary'>8/10</span></p>
                <ul className="nav nav-tabs">
                  <li className="nav-item" role='tablist'>
                    <a className="nav-link active" home-tab="home-tab" data-toggle="tab" href="#home" role='tab'>About</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" home-tab="profile-tab" data-toggle="tab" href="#profile" role='tab'>Timeline</a>
                  </li>
                </ul>
              </div>
            </div>
            <div className='col-lg-2'>
              <button type='submit'  className='btn btn-primary' >Edit Profile</button>
            </div>
          </div>
          <div className='row mt-4'>
            <div className='col-lg-4'>
              <div className='profile-work'>
                <h5>Work Links</h5>
                <a href='https://uamcodes.com/' target='_blank' className='text-secondary'>Portfolio</a> <br/>
                <a href='https://www.linkedin.com/in/muhammad-abdullah-26544824a/' target='_blank' className='text-secondary'>LinkedIn</a> <br/>
                <a href='https://www.instagram.com/cainirecluse/' target='_blank' className='text-secondary'>Instagram</a> <br/>
                <a href='https://www.facebook.com/profile.php?id=100095232774649' target='_blank' className='text-secondary'>Facebook</a> <br/>
              </div>
            </div>
            <div className='col-lg-8'>
              <div className='tab-content profile-tab' id='myTabContent'>
                <div className='tab-pane fade show active' id='home' role='tabpanel' aria-labelledby='home-tab'>
                  <div className='row'>
                    <div className='col-lg-6'>
                      <label >User ID</label>
                    </div>
                    <div className='col-lg-6'>
                      <p className='text-primary'>966966696669</p>
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-lg-6'>
                      <label >Name</label>
                    </div>
                    <div className='col-lg-6'>
                      <p className='text-primary'>{userData.name}</p>
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-lg-6'>
                      <label >Email</label>
                    </div>
                    <div className='col-lg-6'>
                      <p className='text-primary'>{userData.email}</p>
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-lg-6'>
                      <label >Phone</label>
                    </div>
                    <div className='col-lg-6'>
                      <p className='text-primary'>{userData.phone}</p>
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-lg-6'>
                      <label >Work</label>
                    </div>
                    <div className='col-lg-6'>
                      <p className='text-primary'>{userData.work}</p>
                    </div>
                  </div>
                </div>
                <div className='tab-pane fade' id='profile' role='tabpanel' aria-labelledby='profile-tab'>
                  <div className='row'>
                    <div className='col-lg-6'>
                      <label >Experience</label>
                    </div>
                    <div className='col-lg-6'>
                      <p className='text-primary'>Expert</p>
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-lg-6'>
                      <label >Hourly Rate</label>
                    </div>
                    <div className='col-lg-6'>
                      <p className='text-primary'>10$</p>
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-lg-6'>
                      <label >Projects</label>
                    </div>
                    <div className='col-lg-6'>
                      <p className='text-primary'>50+</p>
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-lg-6'>
                      <label >English Proficiency</label>
                    </div>
                    <div className='col-lg-6'>
                      <p className='text-primary'>Expert</p>
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-lg-6'>
                      <label >Availability</label>
                    </div>
                    <div className='col-lg-6'>
                      <p className='text-primary'>8 Months</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
              </div>
         </form> 
        </div>
  </div>
  )
}

export default About